import './ButtonsStyle.css';

export const PlusButton = ({ onClick, disabled }) => {
    return (
        <button className={'button--main plus-button'} onClick={onClick} disabled={disabled}>
            +
        </button>
    );
};